import React from 'react';
import { Badge } from 'react-bootstrap';


interface AttachmentListProps {
  attachments: string;
}

const getFileIcon = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  if (ext === 'pdf') return '📄';
  if (['jpg', 'jpeg', 'png', 'gif'].includes(ext || '')) return '🖼️';
  if (['doc', 'docx'].includes(ext || '')) return '📝';
  return '📎';
};

export const AttachmentList: React.FC<AttachmentListProps> = ({attachments }) => (
  <div className="d-flex flex-wrap gap-2 mt-2">
   
      <Badge
        bg="light"
        text="dark"
        className="d-flex align-items-center gap-2 p-2 border"
      >
        <span>{getFileIcon(attachments)}</span>
        <span className="text-truncate" style={{ maxWidth: '200px' }}>
          {attachments}
        </span>
      </Badge>
    
  </div>
);


